export enum Role {
  User = 'user',
  CanteenAdmin = 'canteen-admin',
  PasswordAdmin = 'password-admin',
}

export const hasRole = (userRoles: Role[], role: Role) => {
  return userRoles.includes(role)
}
